<div class="editor">

  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <div class="config-font">
        <p class="title">Upload file PDF</p>
        <label for="uploadFile" class="upload-label">Upload file</label>
        <input id="uploadFile" hidden type="file" (change)="onFileSelected($event)" accept="application/pdf">
        <p>
          {{
          data_object.nameFile
          }}
        </p>
      </div>
    </div>
  </ng-container>


  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" >
      <!-- HIỂN THỊ -->
      <li nz-submenu [nzTitle]="'hien_thi'| translate" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
      <!-- CHỈNH SỬA NỘI DUNG -->
      <li nz-submenu [nzTitle]="'chinh_sua_noi_dung'| translate" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="config-font">
          <p class="title">Upload file PDF</p>
          <label for="uploadFile" class="upload-label">Upload file</label>
          <input id="uploadFile" hidden type="file" (change)="onFileSelected($event)" accept="application/pdf">
          <p>
            {{
            data_object.nameFile || (pdfTitle + '.pdf')
            }}
          </p>
        </div>
      </li>
      <!-- NHÃN -->
      <li nz-submenu [nzTitle]="'nhan'| translate" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate">
          <mat-label>{{'nhan' | translate}}<span style="color: red">*</span></mat-label>
          <textarea matInput
            [ngModel]="staticdata.accessibility?.['aria_label_' + functionService.selectedLanguageCode] || 'Trình xem tài liệu PDF: '"
            (ngModelChange)="staticdata.accessibility['aria_label_' + functionService.selectedLanguageCode] = $event"
            (blur)="updateContent('aria_label', true);"></textarea>
        </mat-form-field>
        <p class="aria-label-preview">
          aria-label="{{(staticdata.accessibility?.['aria_label_' + functionService.selectedLanguageCode] || 'Trình xem tài liệu PDF: ') + pdfTitle}}"
        </p>
      </li>
    </ul>
  </ng-container>


</div>